/*
 * サブシステム名：請求消込
 * 機能名：売掛残高出力
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdFooterButton from '@/components/DdFooterButton'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import validators from '@/rahmen/validators'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'
import DdRadioButton from '@/components/DdRadioButton'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdYearMonthBoxWithSelector from '@/components/DdYearMonthBoxWithSelector.vue'

export default {
  name: 'UrikakeZandaka',
  mixins: [flowMixin],
  data: () => ({
    conditions: {
      urikakeZandakaSbt: '0',
      searchSeikyuYm: '',
      shukeiYmFromString: '',
      shukeiYmToString: '',
      seikyusakiCd: ''
    },
    headersSeikyusakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    dispZandakaChohyo: '',
    page: 1
  }),
  components: {
    DdSubHeader,
    DdFooterButton,
    DdCodeTextBox,
    DdRadioButton,
    DdDefaultButton,
    DdYearMonthBoxWithSelector
  },
  computed: {
    ...mapGetters({
      seikyusakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki'
    }),
    filteredSeikyusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.seikyusakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsttorihikisakigetseikyusaki'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            var today = new Date()
            self.conditions = {
              urikakeZandakaSbt: '0',
              searchSeikyuYm: ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth() + 1)).slice(-2),
              shukeiYmFromString: '',
              shukeiYmToString: ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth() + 1)).slice(-2),
              seikyusakiCd: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('D2BCLD0050.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('D2BCLD0050.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        restoreViewPromise: (c) => {
          console.log('D2BCLD0050.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    searchSeikyuYm: function (p) {
      this.conditions.searchSeikyuYm = p
    },
    shukeiYmFromString: function (p) {
      this.conditions.shukeiYmFromString = p
    },
    shukeiYmToString: function (p) {
      this.conditions.shukeiYmToString = p
    },
    onPrintButtonClick: function (e) {
      this.clearSummaryMessage()
      if (this.conditions.shukeiYmFromString && this.conditions.shukeiYmToString) {
        var msg = validators.compareYearMonth(this.conditions.shukeiYmFromString, this.conditions.shukeiYmToString)
        if (msg !== undefined) {
          this.$refs.shukeiYmFromString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.shukeiYmToString[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      console.log(e)
      this.Effects.loadStart()
      this.dispZandakaChohyo = this.conditions.urikakeZandakaSbt === 0 ? `売掛残高一覧表_${this.getTimeStamp()}.pdf` : `売掛残高推移表_${this.getTimeStamp()}.pdf`
      // todo:レポート出力
      this.HttpClient
        .requestFileByPost('/api/v1/vwCD2bcld0050/ChohyoPrint', this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('zandakaChohyoPrint')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0007')
          this.Effects.loadComplete()
        })
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
